/**
 * Arrow-key navigation for a hand-rolled `role="radiogroup"` of `role="radio"`
 * buttons (WAI-ARIA: a radiogroup must move selection with ArrowUp/ArrowDown,
 * not Tab alone). Selects + focuses the next/previous enabled radio, clamped at
 * both ends. Attach to the radiogroup container's `onKeyDown`.
 */
import type { KeyboardEvent } from 'react';

export function handleRadioGroupArrowKeys(e: KeyboardEvent<HTMLElement>): void {
  if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
  e.preventDefault();
  const radios = Array.from(
    e.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]:not([disabled])'),
  );
  if (radios.length === 0) return;
  const current = radios.indexOf(document.activeElement as HTMLElement);
  const next =
    e.key === 'ArrowDown'
      ? Math.min(current + 1, radios.length - 1)
      : Math.max(current - 1, 0);
  const target = radios[next < 0 ? 0 : next];
  target.focus();
  // Radios select on arrow-move (native radiogroup semantics).
  target.click();
}
